import { IDictionary, ReadonlyRecord } from '@bimser/core';
import {
	IMenuItem,
	MenuItem,
	MenuItemFactoryFromJS
} from '../../../../../../common/entities/IMenuItem';
import { List, Record, Map } from 'immutable';
import {
	childrenDisplayMode,
	nodeActionType
} from '../../../../../../common/components/panelMenu/entities/enums';
import { Mobile } from '@bimser/common';

interface IBaseRecentAppItem {
	id: string;
	mobileFormView: Mobile.MobileFormView;
	childrenDisplayMode: childrenDisplayMode;
	displayOrderNo: number;
	nodeActionType: nodeActionType;
	nodeKey: string;
	pinned: boolean;
}

export interface IRecentAppItem extends IBaseRecentAppItem {
	caption: IDictionary<string>;
	children: Array<IMenuItem>;
	parameters: IDictionary<string>;
}

export interface IReadonlyRecentAppItem extends IBaseRecentAppItem {
	caption: Map<string, string>;
	children: List<MenuItem>;
	parameters: Map<string, string>;
}

export type RecentAppItem = ReadonlyRecord<IReadonlyRecentAppItem>;

export const RecentAppItemFactory = Record<IReadonlyRecentAppItem>({
	id: '',
	caption: Map<string, string>(),
	mobileFormView: Mobile.MobileFormView.NativePlus,
	childrenDisplayMode: childrenDisplayMode.None,
	children: List<MenuItem>(),
	parameters: Map<string, string>(),
	displayOrderNo: 0,
	nodeActionType: nodeActionType.None,
	nodeKey: '',
	pinned: false
});

export const RecentAppItemFactoryFromJS = function (data: IRecentAppItem) {
	const children: List<MenuItem> = List(
		data?.children?.map((item: IMenuItem) => MenuItemFactoryFromJS(item)) || []
	);

	const caption: Map<string, string> = Map(
		data.caption
			? Object.keys(data.caption).reduce(function (previous: IDictionary<string>, current) {
					previous[current] = data.caption[current];
					return previous;
			  }, {})
			: {}
	);

	const parameters: Map<string, string> = Map(
		data.parameters
			? Object.keys(data.parameters).reduce(function (
					previous: IDictionary<string>,
					current
			  ) {
					previous[current] = data.parameters[current];
					return previous;
			  }, {})
			: {}
	);

	return RecentAppItemFactory({
		...data,
		children,
		caption,
		parameters
	});
};
